import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b3f625e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_realestate_fieldmap",
  ref: "realestateFieldMapModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_realestate_header"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Input the Header Detail", -1))
const _hoisted_6 = {
  id: "kt_modal_add_realestate_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_realestate_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_realestate_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_realestate_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row row-cols-2 g-10" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "card card-bordered mb-10 bg-light-primary" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row row-cols-4 g-1" }
const _hoisted_15 = { class: "card bg-light-primary" }
const _hoisted_16 = { class: "sub-label" }
const _hoisted_17 = ["data-index"]
const _hoisted_18 = ["data-index"]
const _hoisted_19 = ["data-fieldname"]
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "card card-bordered bg-light-primary" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "row row-cols-4 g-1" }
const _hoisted_24 = { class: "card bg-light-primary" }
const _hoisted_25 = ["data-index"]
const _hoisted_26 = ["data-index"]
const _hoisted_27 = ["data-fieldname"]
const _hoisted_28 = { class: "modal-footer flex-center" }
const _hoisted_29 = ["data-kt-indicator"]
const _hoisted_30 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_32 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_33 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue_draggable_container = _resolveComponent("vue-draggable-container")!
  const _component_vue_droppable = _resolveComponent("vue-droppable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_vue_droppable, {
              options: _ctx.options,
              "onDroppable:stop": _ctx.droppingStop
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_vue_draggable_container, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "col"
                                }, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(group.subLabel), 1),
                                    (group.item == '')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "dropzone",
                                          "data-index": index,
                                          type: "group"
                                        }, null, 8, _hoisted_17))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "dropzone draggable-dropzone--occupied",
                                          "data-index": index,
                                          type: "group"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "item",
                                            "data-fieldname": group.item
                                          }, _toDisplayString(group.item), 9, _hoisted_19)
                                        ], 8, _hoisted_18))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_vue_draggable_container, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroups4Import, (field, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "col"
                                }, [
                                  _createElementVNode("div", _hoisted_24, [
                                    (field.item == '')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "dropzone",
                                          "data-index": index,
                                          type: "field"
                                        }, null, 8, _hoisted_25))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "dropzone draggable-dropzone--occupied",
                                          "data-index": index,
                                          type: "field"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "item",
                                            "data-fieldname": field.item
                                          }, _toDisplayString(field.item), 9, _hoisted_27)
                                        ], 8, _hoisted_26))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["options", "onDroppable:stop"])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            type: "reset",
            id: "kt_modal_realestate_fieldmap_cancel",
            class: "btn btn-light me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetFieldMap()))
          }, " Reset "),
          _createElementVNode("button", {
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            class: "btn btn-lg btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFieldMap()))
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, [
                    _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_36))
              : _createCommentVNode("", true)
          ], 8, _hoisted_29)
        ])
      ])
    ])
  ], 512))
}